import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Modal yêu cầu đồng ý điều khoản và chính sách bảo mật khi đăng ký lần đầu
 */
const TermsAcceptanceModal = ({ onAccept, onDecline, userName }) => {
  const [accepted, setAccepted] = useState(false);
  const navigate = useNavigate();

  const handleAccept = () => {
    if (accepted) {
      onAccept({
        termsAccepted: true,
        privacyAccepted: true,
        dataUsageAccepted: true,
        acceptedAt: Date.now(),
      });
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10000,
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          maxWidth: "600px",
          width: "100%",
          maxHeight: "90vh",
          overflow: "hidden",
          boxShadow: "0 25px 50px rgba(0, 0, 0, 0.4)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "24px 32px",
            borderBottom: "1px solid #e5e7eb",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
          }}
        >
          <div style={{ fontSize: "28px", marginBottom: "8px" }}>🎉</div>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              marginBottom: "8px",
            }}
          >
            Chào mừng{userName ? ` ${userName}` : ""}!
          </h2>
          <p style={{ fontSize: "14px", opacity: 0.9 }}>
            Trước khi bắt đầu, vui lòng đồng ý với các điều khoản sau
          </p>
        </div>

        {/* Content */}
        <div
          style={{
            padding: "32px",
            overflowY: "auto",
            flex: 1,
          }}
        >
          {/* Single Checkbox */}
          <div
            style={{
              backgroundColor: "#ffffff",
              border: "2px solid #e5e7eb",
              borderRadius: "12px",
              padding: "20px",
              marginBottom: "24px",
            }}
          >
            <label
              style={{
                display: "flex",
                alignItems: "flex-start",
                cursor: "pointer",
                gap: "12px",
              }}
            >
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                style={{
                  width: "20px",
                  height: "20px",
                  cursor: "pointer",
                  marginTop: "2px",
                  flexShrink: 0,
                }}
              />
              <div style={{ flex: 1 }}>
                <span
                  style={{
                    fontSize: "15px",
                    lineHeight: "1.7",
                    color: "#374151",
                  }}
                >
                  Tôi đã đọc và đồng ý với{" "}
                  <a
                    href="/terms"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#667eea",
                      textDecoration: "underline",
                      fontWeight: "500",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    Điều khoản sử dụng dịch vụ
                  </a>
                  ,{" "}
                  <a
                    href="/policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#667eea",
                      textDecoration: "underline",
                      fontWeight: "500",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    Chính sách bảo mật
                  </a>{" "}
                  và cho phép AIPrice sử dụng dữ liệu của tôi để cải thiện dịch
                  vụ.
                </span>
              </div>
            </label>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "20px 32px",
            borderTop: "1px solid #e5e7eb",
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onDecline}
            style={{
              padding: "12px 24px",
              backgroundColor: "#f3f4f6",
              color: "#374151",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#e5e7eb";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#f3f4f6";
            }}
          >
            Từ chối
          </button>
          <button
            onClick={handleAccept}
            disabled={!accepted}
            style={{
              padding: "12px 32px",
              backgroundColor: accepted ? "#667eea" : "#d1d5db",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: "600",
              cursor: accepted ? "pointer" : "not-allowed",
              transition: "all 0.2s",
              boxShadow: accepted
                ? "0 4px 12px rgba(102, 126, 234, 0.4)"
                : "none",
            }}
            onMouseEnter={(e) => {
              if (accepted) {
                e.target.style.backgroundColor = "#5568d3";
                e.target.style.transform = "translateY(-2px)";
              }
            }}
            onMouseLeave={(e) => {
              if (accepted) {
                e.target.style.backgroundColor = "#667eea";
                e.target.style.transform = "translateY(0)";
              }
            }}
          >
            Đồng ý và tiếp tục
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAcceptanceModal;
